<rt-dialog-header
  [heading]="'tlc.members.add_member_flow_choice_dialog.heading' | translate"
  [subheading]="'tlc.members.add_member_flow_choice_dialog.subheading' | translate"
/>
<rt-dialog-body>
  <div class="cards-container">
    @for (card of cardOptions; track $index) {
      <tla-add-member-flow-choice-card [card]="card" (cardClick)="proceed($event)" />
    }
  </div>
</rt-dialog-body>
